// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__37LnE","dragIcon":"Choice_dragIcon__fznhP","left":"Choice_left__3cBXT","input":"Choice_input__zwdEL"};